import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import hcSquareLogo from '../../../../../assets/images/logo/logo-green-xl.png';
import { colors } from '../../../../lib/colors';
import HomecomingLogo from '../../../ProgramActivitySlideover/ProgramAssessmentPDF/components/HomecomingLogo';

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  brandingRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  wordmarkImage: {
    height: 24,
    maxWidth: 150,
    objectFit: 'contain',
    objectPosition: 'left',
  },
  homecomingLogo: {
    marginBottom: 0,
  },
  poweredBy: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  poweredByPrefix: {
    fontSize: 7,
    color: colors.neutral[110],
    fontFamily: 'sans',
    fontWeight: 400,
  },
  poweredByLogo: {
    width: 8,
    height: 8,
    marginLeft: 2,
    marginRight: 1,
  },
  poweredByBrand: {
    fontSize: 7,
    color: colors.green[125],
    fontFamily: 'serif',
    fontWeight: 500,
  },
  patientInfo: {
    flexDirection: 'column',
  },
  fieldRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: 6,
  },
  fieldLabel: {
    fontSize: 10,
    color: colors.neutral[125],
    fontWeight: 400,
    marginRight: 4,
  },
  fieldLine: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral[100],
    borderBottomStyle: 'solid',
    minWidth: 120,
    height: 14,
  },
});

interface PrintableHeaderProps {
  wordmarkLogoUrl?: string | null;
}

const PrintableHeader: React.FC<PrintableHeaderProps> = ({
  wordmarkLogoUrl,
}) => (
  <View style={styles.container}>
    <View
      style={[
        styles.brandingRow,
        !wordmarkLogoUrl && { justifyContent: 'flex-start' },
      ]}
    >
      {wordmarkLogoUrl ? (
        <Image src={wordmarkLogoUrl} style={styles.wordmarkImage} />
      ) : (
        <View style={styles.homecomingLogo}>
          <HomecomingLogo />
        </View>
      )}
      {wordmarkLogoUrl ? (
        <View style={styles.poweredBy}>
          <Text style={styles.poweredByPrefix}>Powered by</Text>
          <Image src={hcSquareLogo} style={styles.poweredByLogo} />
          <Text style={styles.poweredByBrand}>Homecoming</Text>
        </View>
      ) : null}
    </View>

    <View style={styles.patientInfo}>
      <View style={styles.fieldRow}>
        <Text style={styles.fieldLabel}>Name:</Text>
        <View style={styles.fieldLine} />
      </View>
      <View style={styles.fieldRow}>
        <Text style={styles.fieldLabel}>Date:</Text>
        <View style={styles.fieldLine} />
      </View>
      <View style={styles.fieldRow}>
        <Text style={styles.fieldLabel}>Participant ID:</Text>
        <View style={styles.fieldLine} />
      </View>
    </View>
  </View>
);

export default PrintableHeader;
